<template>
  <div>
    <div id="page" data-swup="0" class="device-is-android">
      <header-bar></header-bar>
      <footer-bar></footer-bar>
      <div
        class="page-content header-clear-medium has-footer-menu"
        style="transform: translateX(0px)"
      >
        <Carousel :interval="4000" height="300px" arrow="always">
          <CarouselItem v-for="task in featuredTasks" :key="`ftrd_${task.id}`">
            <div
              @click="handleDetailModal({ show: true, id: task.id })"
              class="card card-style bg-1"
              data-card-height="300"
              :style="
                `height: 300px;     background-repeat: no-repeat !important; background: url('${task.defaultAttachmentUrl}?w=600&h=450&mode=crop')`
              "
            >
              <div class="card-bottom">
                <h4 class="color-white px-3 mb-0">{{ task.task }}</h4>
                <p class="px-3 color-white font-15 opacity-60"></p>
              </div>
              <div class="card-overlay bg-gradient"></div>
            </div>
          </CarouselItem>
        </Carousel>
        <div class="divider mb-3"></div>
        <div class="card card-style mg-t-20" v-show="tasks.length > 0">
          <div class="content mb-0">
            <!-- {{tasks}} -->
            <template v-for="task in tasks">
              <div
                class="d-flex mb-3"
                :key="`dv_h` + task.id"
                @click="handleDetailModal({ show: true, id: task.id })"
              >
                <div>
                  <a
                    ><img
                      :src="`${task.defaultAttachmentUrl}?h=70&w=70&mode=crop`"
                      width="70"
                      class="rounded-sm"
                  /></a>
                </div>
                <div>
                  <a @click="handleDetailModal({ show: true, id: task.id })">
                    <p class="ps-3 line-height-s color-theme mb-1">
                      {{ task.task }}
                    </p>
                  </a>
                  <p class="mb-0 ps-3 font-10 pt-1 opacity-60">
                    <i class="fa fa-clock pe-2"></i
                    >{{ moment(task.d1).format("YYYY.MM.DD") }}
                  </p>
                </div>
              </div>
              <div class="divider mb-3" :key="`dv_` + task.id"></div>
            </template>
          </div>
        </div>
      </div>

      <div class="page-bg">
        <div></div>
      </div>

      <div class="divider divider-margins"></div>
    </div>
  </div>
</template>

<script>
//const moment = require("moment");
import moment from "moment";

import { request } from "@/api/all";
import { mapActions } from "vuex";
import footerBar from "@/views/apps/ubtzyouth/footerBar";
import headerBar from "@/views/apps/ubtzyouth/headerBar";

import { Carousel, CarouselItem } from "element-ui";

export default {
  components: {
    Carousel,
    CarouselItem,
    footerBar,
    headerBar,
  },
  data() {
    return {
      tasks: [],
      featuredTasks: [],
      title: "",
    };
  },
  created: function() {
    this.moment = moment;
  },
  methods: {
    
    ...mapActions(["handleDetailModal"]),
    init() {
      request({
        api: { method: "POST", url: "taskCore/getCoreList" },
        data: {
          skip: 0,
          size: 100,
          ot: 357,
          model: {
            isPublic: true,
            locTypeId1: this.$route.params.id,
            i1: 0,
          },
        },
        store: this.$store,
      }).then((res) => {
        this.tasks = _.sortBy(
          res.data.tasks.filter((x) => x.i1 == 0),
          "d1", "asc"
        ).reverse();
      });
      request({
        api: { method: "POST", url: "taskCore/getCoreList" },
        data: {
          skip: 0,
          size: 100,
          ot: 357,
          model: {
            isPublic: true,
            locTypeId1: this.$route.params.id,
            i1: 1,
          },
        },
        store: this.$store,
      }).then((res) => {
        this.featuredTasks = _.sortBy(res.data.tasks, "id", "desc");
      });
      request({
        api: { method: "get", url: "Type/GetInheritedDetail" },
        params: {
          id: this.$route.params.id,
        },
        store: this.$store,
      }).then((res) => {
        this.title = res.data.name;
      });
    },
  },
  mounted() {
    this.init();
  },
  watch: {
    "$root.$route"(newRoute, oldRoute) {
      if (newRoute.params.id != oldRoute.params.id) {
        this.init();
      }
    },
  },
};
</script>
<style scoped></style>
